import { render, staticRenderFns } from "./UserLink.vue?vue&type=template&id=d5057bea&scoped=true&"
import script from "./UserLink.vue?vue&type=script&lang=js&"
export * from "./UserLink.vue?vue&type=script&lang=js&"
import style0 from "./UserLink.vue?vue&type=style&index=0&id=d5057bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5057bea",
  null
  
)

export default component.exports